import * as types from '../const/action.types';

export function reportSTSIsLoading(state = false, action) {
    switch (action.type) {
        case types.REPORT_STS_IS_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}

export function report_sts(state = {}, action) {
    switch (action.type) {
        case types.REPORT_STS_FETCH_DATA:
            return action.items;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/api.reports.sts.reducer.js